import { API_URI } from '@/lib/const';

import { getAccessTokenStorage } from './cookieStorage';

const SALEOR_ACCESS_TOKEN_STORAGE_KEY = `${API_URI}+saleor_auth_access_token`;
const AUTHORIZATION_BEARER_HEADER = 'authorization-bearer';

export const getClientAccessToken = (): string =>
  getAccessTokenStorage().getItem(SALEOR_ACCESS_TOKEN_STORAGE_KEY) ?? '';

/**
 * Same-origin BFF fetch with Saleor JWT on authorization-bearer.
 * Does not set Authorization, so TST/PRE Cloudflare Basic Auth is preserved.
 * Token refresh stays with saleorAuthClient.fetchWithAuth / Apollo — not here.
 */
export const fetchStorefrontBffWithAuth = (
  url: string,
  init?: RequestInit,
): Promise<Response> => {
  const token = getClientAccessToken();
  return fetch(url, {
    ...init,
    headers: {
      ...init?.headers,
      [AUTHORIZATION_BEARER_HEADER]: token,
    },
    cache: 'no-store',
  });
};
